import { Icon } from "armstrong-react";
import classNames from "classnames";
import React from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import _ from "underscore";
import { EnumHelper } from "@travellocal/utils/enumHelper";
import { ItineraryDay } from "../core/atoms/atoms";
import { RoutesInvoker } from "../web/routesInvoker";
import { GoogleAnalyticsHelper } from "@travellocal/ui";

interface OwnProps {
  date: string;
  day: IItineraryDaySummary;
  dayIndex: number;
  isSampleItinerary: boolean;
  slug: string;
  isExpanded: boolean;
  handleExpandStateChange: (isExpanded: boolean, dayId: number) => void;
}

interface DispatchProps {
  imageClicked: (itinerarySlug: string, fileName: string, isSampleItinerary: boolean) => void;
}

interface StateProps {
  userState: IState<IUser>;
}

interface LocalState {
  isExpanded?: boolean;
}

type Props = DispatchProps & OwnProps & StateProps;
class ItinerarySummaryViewDayComponent extends React.Component<Props, LocalState> {
  constructor(props: Props) {
    super(props);
    this.state = { isExpanded: this.props.isExpanded };
  }

  // TODO: refactor this into a functional component and replace this with React.useEffect()
  public componentDidUpdate(prevProps) {
    if (this.props.isExpanded !== prevProps.isExpanded) {
      this.setState({ isExpanded: this.props.isExpanded });
    }
  }

  public buildMealBasis(meals: MealType[]): string {
    const mealBasis = [];
    if (meals.indexOf(MealType.Breakfast) !== -1) {
      mealBasis.push("breakfast");
    }
    if (meals.indexOf(MealType.Lunch) !== -1) {
      mealBasis.push("lunch");
    }
    if (meals.indexOf(MealType.Dinner) !== -1) {
      mealBasis.push("dinner");
    }
    if (mealBasis.length === 0) {
      return "no meals included";
    }
    else {
      return mealBasis.join(", ");
    }
  }

  public buildSharedTag(eventType: ComponentType): JSX.Element {
    const eventTypeString = EnumHelper.getComponentTypeDescription(eventType);
    return (<div className={classNames("tag", "tag-shared", eventTypeString)}>Shared {eventTypeString}</div>);
  }

  public showMoreShowLess(isExpanded: boolean, dayId: number) {
    if (!isExpanded) {
      GoogleAnalyticsHelper.logEvent("Show detail", "Click", "Itinerary tab");
    }
    this.props.handleExpandStateChange(!isExpanded, dayId);
  }

  // Don't show the gallery for admins or LTO sales users
  private imageClicked = (fileName: string, userType: UserType): void => {
    if (userType === UserType.Customer) {
      GoogleAnalyticsHelper.logEvent("Image Gallery", "Click", "Open Gallery");
      this.props.imageClicked(this.props.slug, fileName, this.props.isSampleItinerary);
    } else {
      return;
    }
  }

  public render() {
    const userType = this.props.userState.data ? this.props.userState.data.userType : UserType.Customer;
    const eventsDetail = _.map(this.props.day.events, (exn, index) => {

      const images = exn.images.map(image => (

        <div
          key={image.id}
          onClick={() => this.imageClicked(image.fileName, userType)}
          className={classNames("event-image", { clickable: userType === UserType.Customer })}
          title={exn.name}
          style={{ backgroundImage: `url('${image.smallUrl}')` }}
        />
      ));

      return (
        <div className="event-item" key={`exn_${index}`}>
          <div className="columns is-multiline">
            <div className={exn.images.length <= 2 ? "column" : "column is-full"}>
              <h4><Icon className="m-right-xsmall" icon={Icon.Icomoon.location} /> { } {exn.name}</h4>

              <div className="tags">
                {exn.shared && this.buildSharedTag(exn.eventType)}
                {exn.arrangedByCustomer && (
                  <div className="tag tag-self-arranged">Self-arranged</div>
                )}
                {exn.serviceProvider && (
                  <div className="tag tag-service-provider">{exn.serviceProvider}</div>
                )}
                {exn.serviceCode && (
                  <div className="tag tag-service-code">{exn.serviceCode}</div>
                )}
              </div>

              {exn.description &&
                <p>{exn.description}</p>
              }
              {exn.notes &&
                <p>{exn.notes}</p>
              }
            </div>

            {exn.images.length <= 2 &&
              <div className="column is-paddingless is-narrow-tablet">
                <div className="event-images stacked">{images}</div>
              </div>
            }
          </div>

          {exn.images.length > 2 &&
            <div className="event-images stacked-mobile">{images}</div>
          }
        </div>
      );
    });

    const dayDescription = (this.props.day?.locationNames?.length ?? 0) > 0 ? this.props.day.locationNames.join(", ") : "";
    const imageDescription = this.props.day?.image?.description || dayDescription;

    let accommodationImages;

    if (this.props.day.dayAccommodation != null && this.props.day.dayAccommodation.images.length > 0) {
      accommodationImages = this.props.day.dayAccommodation.images.map(image => (
        <div
          key={image.id}
          className={classNames("event-image", { clickable: userType === UserType.Customer })}
          title={this.props.day.dayAccommodation.name}
          style={{ backgroundImage: `url('${image.smallUrl}')` }}
          onClick={() => this.imageClicked(image.fileName, userType)}
        />
      ));
    }

    return (
      <ItineraryDay
        date={this.props.date}
        imageDescription={imageDescription}
        day={this.props.day}
        isExpanded={this.state.isExpanded}
        onClick={(isExpanded) => this.showMoreShowLess(isExpanded, this.props.day.id)}
      >
        <div className="detail-view rs-xlarge-1col columns is-marginless">
          <div className="p-medium">
            {eventsDetail}
          </div>
          {this.props.day.dayAccommodation &&
            <div className="event-item accommodation-item p-medium">
              <div className="columns is-multiline">
                <div className={this.props.day.dayAccommodation.images.length <= 2 ? "column" : "column is-full"}>
                  <h4><Icon className="m-right-xsmall" icon={Icon.Icomoon.home2} />Accommodation: {this.props.day.dayAccommodation.name}</h4>
                  {this.props.day.dayAccommodation.description &&
                    <p>{this.props.day.dayAccommodation.description}</p>
                  }
                  {this.props.day.dayAccommodation.location &&
                    <p>{this.props.day.dayAccommodation.location.name}</p>
                  }
                  {this.props.day.dayAccommodation.roomDescription &&
                    <p><strong>Room description: </strong> {this.props.day.dayAccommodation.roomDescription}</p>
                  }
                  {this.props.day.dayAccommodation.meals && this.props.day.dayAccommodation.meals.length !== 0 &&
                    <p><strong>Meals included: </strong> {this.buildMealBasis(this.props.day.dayAccommodation.meals)}</p>
                  }
                  {this.props.day.dayAccommodation.notes &&
                    <p><strong>Notes: </strong> {this.props.day.dayAccommodation.notes}</p>
                  }
                  {this.props.day.dayAccommodation.url && !this.props.isSampleItinerary &&
                    <p><strong>Hotel website: </strong> <a target="_blank" rel="noreferrer" href={this.props.day.dayAccommodation.url}>{this.props.day.dayAccommodation.url}</a></p>
                  }
                </div>
                {this.props.day.dayAccommodation.images.length <= 2 &&
                  <div className="column is-paddingless is-narrow-tablet">
                    <div className="event-images stacked">{accommodationImages}</div>
                  </div>
                }
              </div>
              {this.props.day.dayAccommodation.images.length > 2 &&
                <div className="event-images stacked-mobile">{accommodationImages}</div>
              }
            </div>
          }
          {this.props.day.accommodationArrangedByCustomer &&
            <div className="event-item accommodation-item p-medium">
              <p><em>No accommodation is included for this night.</em></p>
            </div>
          }
        </div>
      </ItineraryDay>
    );
  }
}

const stateToProps = (state: IAppStoreState): StateProps => ({
  userState: state.user,
});

const mapDispatchToProps = (dispatch): DispatchProps => {
  return {
    imageClicked: (itinerarySlug: string, fileName: string, isSampleItinerary: boolean) =>
      dispatch(push(RoutesInvoker.itineraryGalleryImage(itinerarySlug, fileName, isSampleItinerary))),
  };
};
export const ItinerarySummaryViewDay = connect<StateProps, DispatchProps, OwnProps>(stateToProps, mapDispatchToProps)(ItinerarySummaryViewDayComponent);
